import { Component } from '@angular/core';
import { AuthService } from '../../../services/auth.service';

@Component({
  selector: 'prof-topnav-progressive-profile',
  templateUrl: './topnav-progressive-profile.component.html',
  styleUrl: './topnav-progressive-profile.component.scss',
  standalone: false
})
export class TopnavProgressiveProfileComponent {
  constructor(public auth: AuthService) {}
}
